module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('mu-appbar', {
    staticClass: "center"
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/home/index"
    },
    slot: "left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "keyboard_arrow_left",
      "color": "white"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "topT left"
  }, [_vm._v("提示")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check_outline",
      "color": "#27ba69",
      "size": 50
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("订单提交成功!")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._v("\n                如您到店较晚，建议您先支付房费，我们将一直为您保留房间至"), _c('span', {
    staticClass: "mark"
  }, [_vm._v("【退房当日】 12:00")]), _vm._v("，期间可随时入住。"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "mark"
  }, [_vm._v(_vm._s(_vm.g_searchParam.startDate) + " 18:00")]), _vm._v("之前取消订单可全额退款。超时或未入住将收取您首日房费。\n            ")]), _vm._v(" "), _c('mu-divider')], 1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('mu-raised-button', {
    staticClass: "btn btn1",
    attrs: {
      "label": "取消预订"
    },
    on: {
      "click": _vm.toOrder
    }
  }), _vm._v(" "), (_vm.g_PayOrder.BookType == 0 && _vm.g_PayOrder.Money > 0) ? _c('mu-raised-button', {
    staticClass: "btn btn2",
    attrs: {
      "label": "支付房费",
      "primary": ""
    },
    on: {
      "click": _vm.toPay
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-205d5249!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/orderSuccess.vue
// module id = 1440
// module chunks = 18